<template>
  <div class="container-fluid mt-3">
    <div class="row">
      <div class="col">
        <div v-if="success" class="mt-4">
          <programa-tab :call="call">
            <div slot="footer">
              <div class="card-footer text-center">
                <argon-alert type="success" class="mb-0"
                  >Inscrição realizada com sucesso!</argon-alert
                >
              </div>
            </div>
          </programa-tab>
        </div>
        <div class="text-center col-10 mx-auto" v-else-if="error">
          <argon-alert color="danger"
            >Ocorreu um erro ao recuperar as informações. Por favor, verifique o
            endereço informado e tente novamente.</argon-alert
          >
        </div>
        <form-wizard
          :color="$store.state.auth.secondary_color"
          :errorColor="
            $store.getters.brightColor({
              color: $store.state.auth.secondary_color,
              gradient: -50,
            })
          "
          v-else
          class="container"
        >
          <template slot="title">
            <div class="col-12">
              <h3 class="text-light font-weight-normal">Ficha de Inscrição</h3>
            </div>
          </template>
          <!-- Programa -->
          <tab-content title="Programa" icon="ni ni-planet">
            <div class="vld-parent" ref="programa_container">
              <programa-tab :call="call" />
            </div>
          </tab-content>
          <!-- Apresentação -->
          <tab-content
            title="Apresentação"
            icon="fas fa-file-video"
            :before-change="() => validateStep(this.model.presentation)"
          >
            <div class="card card-profile shadow">
              <div class="card-body mt-2 py-3">
                <div class="row">
                  <div class="col-12 mb-3">
                    <h6 class="heading-small text-muted">Pitch deck</h6>
                  </div>
                  <div class="col-12 ml-lg-2">
                    <p class="text-muted">
                      <i class="far fa-file-pdf mr-2"></i> deve ser uma
                      apresentação em
                      <b class="font-weight-bold">formato PDF</b> contendo
                      <b class="font-weight-bold">até 10 slides</b>. O arquivo
                      deve ter um
                      <b class="font-weight-bold">tamanho máximo de 5mb</b>.
                    </p>
                  </div>
                  <div class="col-12 ml-lg-2">
                    <file-select
                      v-model="model.presentation.pitch_deck"
                      title="Selecione o deck"
                      accept="application/pdf"
                      type="primary"
                      :mbSize="5"
                    ></file-select>
                  </div>
                </div>
                <hr class="my-4" />
                <div class="row">
                  <div class="col-12 mb-3">
                    <h6 class="heading-small text-muted">Pitch vídeo</h6>
                  </div>
                  <div class="col-12">
                    <p class="text-muted">
                      <i class="fab fa-youtube mr-2"></i> deve ser um vídeo no
                      <b class="font-weight-bold">YouTube</b> (com
                      compartilhamento de link e preferencialmente não listado)
                      de até <b class="font-weight-bold">3 minutos</b>.
                    </p>
                  </div>
                  <div class="col-md-6">
                    <argon-input
                      v-model="model.presentation.pitch_video_url"
                      addon-left-icon="fas fa-link"
                      placeholder="Cole aqui o link do vídeo no YouTube"
                      class="mb-2"
                    />
                  </div>
                  <div
                    class="col-md-6 pt-2 text-center text-lg-left"
                    v-show="model.presentation.pitch_video_url"
                  >
                    <a
                      v-if="extractYoutubeVideoId()"
                      :href="
                        'https://www.youtube.com/watch?v=' +
                        model.presentation.pitch_video_youtube_id
                      "
                      target="_blank"
                      class="btn btn-default btn-sm"
                      v-tooltip="
                        'Verifique se o vídeo está abrindo corretamente em outra aba do navegador.'
                      "
                      >verificar link</a
                    >
                    <span
                      v-else
                      class="text-sm text-danger"
                      v-tooltip="
                        `Uma URL válida possuí um formato do tipo 'https://www.youtube.com/watch?v=<video_id>', onde <video_id> é o indentificador do vídeo.`
                      "
                      ><i class="fas fa-info-circle mr-1"></i> A URL ainda não
                      está em um formato válido.</span
                    >
                  </div>
                </div>
                <hr class="my-4" />
                <div class="row">
                  <div class="col-12 ml-lg-2">
                    <p class="pt-2 mb-1">
                      <b>#Dica</b>: Confirme se seu pitch aborda os seguintes
                      itens:
                    </p>
                    <ul class="description">
                      <li>
                        Descrição do produto e/ou serviço que pretende
                        desenvolver. Além das oportunidades identificadas e
                        problemas que serão resolvidos;
                      </li>
                      <li>
                        Benefícios, diferenciais, vantagens competitivas,
                        funções e aplicações do seu projeto;
                      </li>
                      <li>
                        Em quais mercados/segmentos atua ou pretende atuar e,
                        seus potenciais concorrentes;
                      </li>
                      <li>
                        Como você pensa em comunicar, promover (vender) e
                        distribuir o seu produto/serviço?
                      </li>
                      <li>
                        Para o pitck deck: desenvolver análise SWOT
                        (<b>S</b>trenghts = Forças, <b>W</b>eaknesses =
                        Fraquezas, <b>O</b>pportunities = Oportunidades e
                        <b>T</b>hreats = Ameaças).
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="text-center mt-4" v-if="errors.stepError.show">
                  <argon-alert color="danger">{{
                    errors.stepError.text
                  }}</argon-alert>
                </div>
              </div>
            </div>
          </tab-content>
          <!-- Projeto --->
          <tab-content
            title="Projeto"
            icon="fas fa-clipboard-list"
            :before-change="() => validateStep(this.model.project)"
          >
            <div class="card card-profile shadow">
              <div class="card-body mt-2 py-3">
                <div class="row">
                  <div class="col-12 mb-3">
                    <h6 class="heading-small text-muted">
                      Proposta do projeto
                    </h6>
                  </div>
                </div>
                <div class="row ml-lg-2">
                  <div class="col-lg-12">
                    <argon-input
                      label="Título"
                      v-model="model.project.project_title"
                      placeholder="Digite o título do projeto"
                    />
                  </div>
                  <div class="col-lg-6">
                    <div class="form-group has-label">
                      <label class="form-control-label"
                        >Setor primário de atuação</label
                      >
                      <select
                        class="form-select"
                        v-model="model.project.project_sector"
                      >
                        <option value="" selected disabled>
                          Selecione uma opção
                        </option>
                        <option
                          v-for="(sector, index) in sectors"
                          :key="index"
                          :value="sector"
                        >
                          {{ sector }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-group has-label">
                      <label class="form-control-label">Estágio atual</label>
                      <select
                        class="form-select"
                        v-model="model.project.project_stage"
                      >
                        <option value="" selected disabled>
                          Selecione uma opção
                        </option>
                        <option
                          v-for="stage in Object.keys(stages)"
                          :key="'stage_' + stage"
                          :value="stage"
                        >
                          {{ stages[stage] }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <argon-input label="Descrição do projeto">
                      <template #customInput>
                        <textarea
                          rows="3"
                          v-model="model.project.project_description"
                          class="form-control"
                          placeholder="Faça uma breve descrição do projeto aqui..."
                        >
                        </textarea>
                      </template>
                    </argon-input>
                  </div>
                </div>
                <hr class="my-4" />
                <div class="row">
                  <div class="col-12 mb-3">
                    <h6 class="heading-small text-muted">
                      Informações do responsável
                    </h6>
                  </div>
                </div>
                <div class="row ml-lg-2">
                  <div class="col-lg-6">
                    <argon-input
                      label="Nome completo do responsável"
                      v-model="model.project.responsible_name"
                      placeholder="Digite o nome completo do responsável"
                    />
                  </div>
                  <div class="col-lg-6">
                    <argon-input
                      label="Titulação máxima"
                      v-model="model.project.responsible_scolarity"
                      placeholder="Qual a tituação máxima obtida?"
                    />
                  </div>
                  <div class="col-lg-6">
                    <argon-input
                      label="CPF do responsável"
                      mask="###.###.###-##"
                      v-model="model.project.responsible_cpf"
                      type="tel"
                      placeholder="Digite o CPF do responsável"
                    >
                    </argon-input>
                  </div>
                  <div class="col-lg-6">
                    <label class="form-control-label"
                      >Telefone (com DDD) do responsável</label
                    >
                    <argon-input
                      addonLeftIcon="fab fa-whatsapp"
                      mask="['(##) ####-####', '(##) #####-####']"
                      v-model="model.project.responsible_phone"
                      type="tel"
                      placeholder="Telefone (fixo ou celular)"
                    >
                    </argon-input>
                  </div>

                  <div class="col-lg-12">
                    <estados
                      labelClasses="estado-font"
                      selectClasses="form-select-md"
                      estadoLabel="Estado do responsável"
                      cidadeLabel="Cidade do responsável"
                      :selectedEstado="model.project.responsible_state"
                      :selectedCidade="model.project.responsible_city"
                      @inputEstado="model.project.responsible_state = $event"
                      @inputCidade="model.project.responsible_city = $event"
                    />
                  </div>
                  <div class="col-lg-6 mt-2">
                    <argon-input
                      label="Endereço do responsável"
                      v-model="model.project.responsible_address"
                      placeholder="Digite o endereço"
                    />
                  </div>
                  <div class="col-lg-6 mt-2">
                    <argon-input
                      type="email"
                      label="Email do responsável"
                      addon-left-icon="ni ni-email-83"
                      v-model="model.project.responsible_email"
                      placeholder="Digite o email"
                    />
                  </div>
                  
                </div>
                <hr class="my-4" />
                <div class="row">
                  <div class="col-12 mb-3">
                    <h6 class="heading-small text-muted">
                      Informações da equipe
                    </h6>
                  </div>
                </div>
                <div class="row ml-lg-2">
                  <div class="col-lg-12">
                    <argon-input label="Descrição da equipe">
                      <template #customInput>
                        <textarea
                          rows="3"
                          v-model="model.project.team_description"
                          class="form-control"
                          placeholder="Se aplicável, liste as pessoas envolvidas no projeto e suas respectivas funções (cite também o curso de formação e o ano de formatura). Se apenas o responsável fizer parte do projeto no momento, utilize o espaço para uma breve biografia."
                        >
                        </textarea>
                      </template>
                    </argon-input>
                  </div>
                </div>
                <div class="text-center mt-4" v-if="errors.stepError.show">
                  <argon-alert color="danger">{{
                    errors.stepError.text
                  }}</argon-alert>
                </div>
              </div>
            </div>
          </tab-content>
          <template #footer="props">
            <div class="wizard-footer-left">
              <argon-button
                v-if="props.activeTabIndex > 0"
                @click.native="props.prevTab()"
                :style="props.fillButtonStyle"
              >
                Voltar</argon-button
              >
            </div>
            <div class="wizard-footer-right">
              <argon-button
                v-if="!props.isLastStep"
                @click.native="props.nextTab()"
                class="wizard-footer-right"
                :style="props.fillButtonStyle"
                >Avançar
              </argon-button>
              <argon-button
                v-else
                @click.native="onComplete()"
                class="wizard-footer-right finish-button"
                :style="props.fillButtonStyle"
                >Concluir inscrição</argon-button
              >
            </div>
          </template>
        </form-wizard>
        <modal
          :show.sync="modals.confirmation"
          modal-classes="modal-dialog-centered"
        >
          <template #header>
            <h4 slot="header" class="modal-title" id="modal-title-notification">
              Atenção!
            </h4>
          </template>
          <div class="vld-parent" ref="modal_confirmation">
            <div class="py-3 text-center">
              <i class="fa fa-plane fa-3x"></i>
              <h4 class="heading mt-4">Quase lá!</h4>
              <p class="mt-3">
                Você realmente deseja concluir sua inscrição na chamada
                <span class="font-weight-bold">{{ call.name }}</span
                >?
              </p>
              <p class="text-sm">
                <i class="fas fa-info-circle mr-1"></i> Ao prosseguir, você
                confirma que os dados informados são verdadeiros e refletem o
                estado atual da startup.
              </p>
            </div>
          </div>
          <template #footer>
            <argon-button
              type="link"
              color="gray-400"
              class="ml-auto"
              @click="modals.confirmation = false"
            >
              Voltar
            </argon-button>
            <argon-button
              type="white"
              color="success"
              variant="gradient"
              @click="handleSubmit"
              :disabled="modals.disabledSubmit"
            >
              Confirmar inscrição
            </argon-button>
          </template>
        </modal>
      </div>
    </div>
  </div>
</template>
<script>
import ProgramaTab from "./ProgramaTab";
import { FORMCALLSP} from "@/store/cacheConstants";
import { FormWizard, TabContent, WizardButton } from "vue3-form-wizard";
import "vue3-form-wizard/dist/style.css";
import Estados from "@/components/Estados";
import store from "@/store/index.js";
import api from "@/services/api.js";

export default {
  name: "inscricao",
  components: {
    Estados,
    ProgramaTab,
    FormWizard,
    TabContent,
    WizardButton,
  },
  data() {
    return {
      call: {
        name: "",
        status: "",
        link: "",
        type: "",
        region: "",
        region_limited: false,
        start_date: "",
        end_date: "",
        max_startups: "",
        sectors: "",
        description: "",
        observation: "",
      },
      model: {
        presentation: {
          pitch_deck: null,
          pitch_video_url: "",
          pitch_video_youtube_id: "",
        },
        project: {
          project_title: "",
          project_sector: "",
          project_stage: "",
          project_description: "",
          responsible_name: "",
          responsible_scolarity: "",
          responsible_cpf: "",
          responsible_state: "",
          responsible_city: "",
          responsible_address: "",
          responsible_phone: "",
          responsible_email: "",
          team_description: "",
        },
      },
      stages: {
        concept: "Somente conceito",
        prototype: "Protótipo",
        ready: "Teste de mercado e comercialização",
      },
      sectors: [
        "Aeroespacial",
        "Agricultura",
        "Alimentos e bebidas",
        "Biotecnologia",
        "Computadores e periféricos",
        "Construção",
        "Consultoria",
        "Dispositivos e equipamentos médicos",
        "Educação",
        "Eletrônica/instrumentação",
        "Esportes",
        "Estilo de vida",
        "Imóveis",
        "Indústria/energia",
        "Internet/serviços da web",
        "Jogos",
        "Jurídico",
        "Marketing digital",
        "Marketing/publicidade",
        "Marítimo",
        "Mineração",
        "Moda",
        "Mídias e entretenimento",
        "Nanotecnologia",
        "Náutica/Navegação",
        "Petróleo e gás",
        "Produtos da empresa",
        "Produtos de consumo",
        "Redes e equipamentos",
        "Robótica",
        "Segurança",
        "Semicondutores",
        "Serviços a empresas",
        "Serviços ao consumidor",
        "Serviços de saúde",
        "Serviços de TI",
        "Serviços financeiros",
        "Serviços móveis",
        "Software",
        "Substâncias e produtos químicos",
        "Tecnologia limpa",
        "Tecnologia para finanças",
        "Telecomunicações",
        "Transportes",
        "Turismo",
        "Varejo/distribuição",
        "Outro",
      ],
      errors: {
        stepError: {
          show: false,
          text: "Por favor, preencha todos os campos antes de continuar.",
        },
        submitError: {
          show: false,
          text:
            "Ocorreu um erro ao realizar a inscrição. Verifique os dados e tente novamente.",
        },
      },
      modals: {
        confirmation: false,
        disabledSubmit: false,
      },
      success: false,
      error: false,
    };
  },
  async mounted() {
    let loader = this.$loading.show({
      container: this.$refs.programa_container,
      width: 140,
      height: 140,
      opacity: 1,
    });
    try {
      const { data } = await api.get(
        `public/startup-calls/${this.$route.params.slug}`
      );
      if (data.sectors) data.sectors = data.sectors.split(";").filter((s) => s);
      Object.assign(this.call, data);
      this.model = JSON.parse(localStorage.getItem(FORMCALLSP))  || this.model;
      if(this.model.presentation.pitch_deck) this.model.presentation.pitch_deck = null;
    } catch (e) {
      this.$error.errorMessageToast(
        "Ocorreu um erro ao recuperar as informações",
        e
      );
      this.error = true;
    } finally {
      loader.hide();
    }
  },
  methods: {
    async handleSubmit() {
      this.modals.disabledSubmit = true;
      this.errors.submitError.show = false;
      const loader = this.$loading.show({
        container: this.$refs.modal_confirmation,
        opacity: 0,
        width: 140,
        height: 140,
      });
      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      const data = new FormData();
      const presentation = this.model.presentation;
      data.append(
        "deck",
        presentation.pitch_deck,
        presentation.pitch_deck.name
      );
      data.append(
        "pitch_youtube_id",
        this.model.presentation.pitch_video_youtube_id
      );
      data.append("project", JSON.stringify(this.model.project));
      
      try {
        await api.request({
          timeout: 60000,
          method: "post",
          url: `public/pre-incubacao/startup-calls/${this.$route.params.slug}/subscriptions`,
          data,
          config,
        });
        this.$toast.info("Inscrição realizada com sucesso!");
        this.modals.confirmation = false;
        this.success = true;
        store.commit("dropFormCalls", FORMCALLSP);
      } catch (e) {
        this.$error.errorMessageToast(
          "Ocorreu um erro ao realizar a inscrição",
          e
        );
        this.errors.submitError.show = true;
        this.modals.confirmation = false;
      } finally {
        loader.hide();
        this.modals.disabledSubmit = false;
      }
    },
    onComplete: function () {
      if (this.validateStep(this.model.project)) {
        this.modals.confirmation = true;
      }
    },
    validateStep(obj) {
      for (const key in obj) {
        if (obj[key] === "" || obj[key] === null) {
          this.errors.stepError.show = true;
          return false;
        }
      }
      this.errors.stepError.show = false;
      return true;
    },
    extractYoutubeVideoId() {
      let video_id = this.model.presentation.pitch_video_url.split("v=")[1];
      if (!video_id) {
        this.model.presentation.pitch_video_youtube_id = "";
        return false;
      }
      const ampersandPosition = video_id.indexOf("&");
      if (ampersandPosition != -1)
        video_id = video_id.substring(0, ampersandPosition);
      this.model.presentation.pitch_video_youtube_id = video_id;
      return true;
    },
  },
  computed: {
    isLastStep() {
      if (this.$refs.wizard) {
        return this.$refs.wizard.isLastStep;
      }
      return false;
    },
  },
  watch: {  
    model: {
      handler: function () {
        const currentModel = JSON.stringify(this.model);
        const defaultModel = JSON.stringify(this.$options.data().model); 
        if (!(currentModel === defaultModel)) store.commit("storeFormCalls", { key: FORMCALLSP, data: JSON.stringify(this.model) }); 
        
      },
      deep: true,
    }
  }
};
</script>
<style scoped>
.estado-font {
  font-size: 15px;
}

.finish-button {
  background-color: #43a047 !important;
  border-color: #43a047 !important;
}

.finish-button:hover,
.finish-button:focus,
.finish-button:active {
  background-color: #1e8623 !important;
  border-color: #1e8623 !important;
}

.vue3-form-wizard .wizard-btn {
  padding: 9px 12px;
}
</style>
<style>
.vue3-form-wizard .wizard-nav-pills > li > a span.stepTitle:not(.active) {
  color: #bbbbbb !important;
}
</style>
